import './LatLongDisplay.scss';

export const LatLongDisplay = ({ latitude, longitude }) => {
  return (
    <div className="lat-long-display">
        {latitude !== null && latitude !== undefined && longitude !== null && longitude !== undefined &&
            <a href={`https://www.google.com/maps?z=12&t=m&q=loc:${latitude.toFixed(6)}+${longitude.toFixed(6)}`} target="_blank" rel="noopener noreferrer">
                {latitude.toFixed(6)}, {longitude.toFixed(6)}
            </a>
        }
        {(latitude === null || latitude === undefined || longitude === null || longitude === undefined) &&
            <>Unknown</>
        }
    </div>
  );
};
